<template>
    <div class="plan_board">
        <!--SP用ヘッダー-->
        <div class="sp">
            <div class="menu">
                <div class="logo">
                    <router-link to="/"><img src="../assets/images/logo.svg" alt="logo" style="width:100%"></router-link>
                </div>
                <div class="sukikamo_list_sp">
                    <router-link to="/mypage"><img src="../assets/images/list_msg_sp.svg" alt="すきカモリスト"></router-link>
                    <div class="buttons">
                        <LoginButton/>
                    </div>
                </div>
            </div>
        </div>

        <!--PC用ホームボタン,戻るボタン-->
        <HomeBackButton/>

<!--            <div class="pdf_btn">-->
<!--                <a class="pdf_sukikamo" href=""><img src="../assets/images/pdf_sukikamo.svg" alt="PDFを書き出す"></a>-->
<!--            </div>-->
        <div class="plan_board_main_top">
            <!--タイトル-->
            <h2><img src="../assets/images/myhome_tittle.svg" alt="マイホームできたカモ"></h2>
            <!--背景屋根-->
            <div class="background-image">
                <img class="pc" src="../assets/images/background_img.svg" alt="background-image"><!--背景屋根PC-->
                <img class="sp" src="../assets/images/background_img.png" alt="background-image"><!--背景屋根SP-->
            </div>
        </div>
        <!--マイホームできたカモリスト表示-->
        <div class="plan_board_back">
            <div class="plan_board_main">
                <p>選んだ写真であなたのおうちがイメージできます。<br>空間のコーディネートにお役立てください。</p>

                <div v-if="plan_board_items.length" class="plan_board_items">
                    <div class="itemsBox" v-for="(item, i) in plan_board_items" :key="i">
                        <router-link :to="`/room/${item.photo_id}`">
                            <div class="plan_board_imgBox">
                                <img v-if="item.image_name" :src="`${root_path}room_image/${item.image_name}.jpg`" alt="room_image">
                                <img v-else :src="item.url" alt="room_image">
                            </div>
                            <div class="plan_board_text">{{item.name}}</div>
                        </router-link>
                    </div>
                </div>

                <div v-else class="plan_board_empty">
                    <div>プランボードに登録された画像がありません。</div>
                </div>
            </div>
        </div>

        <!--SP用フッター-->
        <div class="sp">
            <div class="footer_box">
<!--                <div class="pdf_btn_sp"><router-link to="/mypage/planboard"><img src="../assets/images/pdf_sukikamo.svg" alt="マイホームできたカモ"></router-link></div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import Ajax from '../assets/js/Ajax'
    import AppPath from '../assets/js/AppPath'
    import LoginButton from '../components/LoginButton'
    import HomeBackButton from '../components/HomeBackButton'

    export default {
        name: "PlanBoard",
        components: { LoginButton, HomeBackButton },
        data: () => ({
            root_path: AppPath.root,
            plan_board_items: []
        }),
        async created() {
            this.plan_board_items = await Ajax.getPlanBoardItems();
        }
    }
</script>

<style scoped lang="scss">
    /*ページ全体*/
    .plan_board{
        padding: 10px 0 300px;
        .plan_board_main_top {
            position: relative;
            max-width: 750px;
            margin: 80px auto 0;
            /*背景屋根*/
            .background-image {
                position: absolute;
                top: -68px;
                left: -125px;
                z-index: -5;
                img {
                    max-width: none!important;
                }
            }

            /*タイトル*/
            h2 {
                text-align: center;
            }
        }
        /*ホームボタン、戻るボタン*/
        .homebtn {
            top: 100px;
        }
        .back_btn {
            top: 150px;
        }
        .homebtn,
        .back_btn {
            position: fixed;
            left: 13%;
            @media screen and (max-width:1800px) {
                left: 10%;
            }
            @media screen and (max-width:1700px) {
                left: 7%;
            }
            @media screen and (max-width:1600px) {
                left: 4%;
            }
            z-index: 50;
        }
        /*マイホームできたカモフォルダ一覧表示エリア*/
        .plan_board_back {
            max-width: 1000px;
            margin: 0 auto 40px;
            background-color: #f2f2f2;
            border-radius: 8px;
            /*padding-top: 80px;*/
            /*マイホームできたカモフォルダ一覧*/
            .plan_board_main {
                position: relative;
                max-width: 750px;
                margin: 0 auto;
                /*テキスト*/
                p {
                    color: #826e67;
                    text-align: center;
                    margin: 40px 0;
                }
                .plan_board_empty{
                    text-align: center;
                    padding: 7rem 0.5rem;
                }
                /*サムネイル画像表示*/
                .plan_board_items{
                    display: flex;
                    flex-wrap: wrap;
                    .itemsBox {
                        width: 220px;
                        margin: 0 15px 60px;
                        text-align: center;
                        .plan_board_text {
                            color: #816e66;
                        }
                        .plan_board_imgBox {
                            display: table-cell;
                            width: 220px;
                            height: 220px;
                            text-align: center;
                            vertical-align: middle;
                            /*> *{*/
                            /*    width: 33.333%;*/
                            img{
                                width:auto;
                                height:auto;
                                max-width:220px;
                                max-height:220px;
                                margin-bottom: -7px;
                                /*}*/
                            }
                        }
                    }
                }
            }
        }
        /*PDFボタン*/
        /*.pdf_btn {*/
        /*    position: relative;*/
        /*    .pdf_sukikamo {*/
        /*        position: fixed;*/
        /*        right: 160px;*/
        /*        bottom: 70px;*/
        /*    }*/
        /*}*/
    }

    @media screen and (max-width:639px) {
        /*ページ全体*/
        .plan_board {
            width: 100%;
            padding: 2px 0 200px;
            box-sizing: border-box;
            box-shadow: initial;
            /*SP用ヘッダー*/
            .menu {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                max-width: 100%;
                min-width: 100%;
                position: fixed;
                background: white;
                margin-top: -2px;
                padding: 2px 10px 0;
                z-index: 20;
                box-sizing: border-box;
                .logo {
                    width: 95px;
                }
                /*すきカモリストボタン*/
                .sukikamo_list_sp {
                    display: flex;
                    img {
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                /*ログインボタン*/
                .buttons {
                    position: relative;
                    display: flex;
                }
            }
        }
        /*SP用フッター*/
        .footer_box {
            display: flex;
            width: 100%;
            height: 65px;
            padding: 10px 10px 10px 0;
            box-sizing: border-box;
            position: fixed;
            bottom: 0;
            z-index: 10;
            /*PDFボタン*/
            /*.pdf_btn_sp {*/
                /*margin: -39px 0 0 auto;*/
                /*img {*/
                /*    height: 86px;*/
                /*}*/
            /*}*/
        }

        .plan_board {
            /*戻るボタン*/
            .back_btn {
                width: 10px;
                top: 130px;
                left: 10px;
            }
            .plan_board_main_top {
                position: relative;
                max-width: 100%;
                margin: 135px auto 0;
                /*タイトル*/
                h2 {
                    background-color: #f2f2f2;
                    margin: 0!important;
                    img{
                        width: 200px;
                    }
                }
                /*背景屋根*/
                .background-image {
                    width: 100%;
                    top: -22px;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    img {
                        width: 100%;
                    }
                }
            }
            /*マイホームできたカモフォルダ一覧表示エリア*/
            .plan_board_back {
                max-width: 1000px;
                margin: 0 auto 40px;
                background-color: #f2f2f2;
                border-radius: 0 0 8px 8px;
                /*padding-top: 80px;*/
                /*マイホームできたカモフォルダ一覧*/
                .plan_board_main {
                    position: relative;
                    max-width: 750px;
                    margin: 0 auto;
                    font-size: 11px;
                    /*テキスト*/
                    p {
                        color: #826e67;
                        text-align: center;
                        margin: 0 0 40px;
                        padding-top: 30px;
                    }
                    /*サムネイル画像表示*/
                    .plan_board_items {
                        display: flex;
                        flex-wrap: wrap;
                        width: 332px;
                        margin: 0 auto;
                        .itemsBox {
                            width: 136px;
                            height: 150px;
                            margin: 0 15px 60px;
                            text-align: center;
                            .plan_board_text {
                                color: #816e66;
                                font-size: 13px;
                            }
                            .plan_board_imgBox {
                                display: table-cell;
                                width: 136px;
                                height: 150px;
                                text-align: center;
                                vertical-align: middle;
                                /*> *{*/
                                /*    width: 33.333%;*/
                                img {
                                    width: auto;
                                    height: auto;
                                    max-width: 136px;
                                    max-height: 150px;
                                    margin-bottom: -7px;
                                    /*}*/
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
